export interface TaskAssigneeOption {
  disabled?: boolean;
  id: string;
  label: string;
}

interface BubbleRole {
  bubbleId?: string | null;
  role?: string | null;
}

interface SalesPerson {
  bubbleRoles?: BubbleRole[] | null;
  firstName?: string | null;
  id?: string | null;
  lastName?: string | null;
}

const SALES_ROLE = "Sales";

const displayName = (person: { firstName?: string | null; lastName?: string | null }, fallback: string) => {
  const name = [person.firstName, person.lastName].filter(Boolean).join(" ").trim();
  return name || fallback;
};

/** Sales-role users on this bubble. Keeps a current assignee who is no longer in the bubble. */
export const taskAssigneesForBubble = (
  users: SalesPerson[],
  bubbleId: string | undefined,
  current?: SalesPerson,
): TaskAssigneeOption[] => {
  const seen = new Set<string>();
  const options: TaskAssigneeOption[] = [];

  if (bubbleId) {
    for (const user of users) {
      if (!user.id || seen.has(user.id)) {
        continue;
      }
      const inBubble = user.bubbleRoles?.some((role) => role.bubbleId === bubbleId && role.role === SALES_ROLE);
      if (!inBubble) {
        continue;
      }
      seen.add(user.id);
      options.push({ id: user.id, label: displayName(user, "Salesperson") });
    }
  }

  if (current?.id && !seen.has(current.id)) {
    options.push({
      disabled: true,
      id: current.id,
      label: displayName(current, "Current assignee"),
    });
  }

  return options;
};
